import React, { useState } from 'react';
import { Modal } from 'react-bootstrap'; 
import styled, {createGlobalStyle} from 'styled-components';

const GlobalModalStyle = createGlobalStyle`
  .modal-open {
    padding-right: 0px !important;
  }
`;

const InfoIcon = ({ title, instructions }) => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(prevShowModal => !prevShowModal);
  };

  return (
    <div>
      <img
        className="d-md-none neutral-charcoal-filter ms-2"
        style={{ width: "28px", height: "28px" }}
        src={Window.static_path + "img/icons/info-circle.svg"}
        onClick={toggleModal}
        alt="Info"
      />

      <Modal
        className='pe-0 modal-open' 
        style={{maxWidth:'355px', paddingLeft:'0px'}} 
        show={showModal}
        onHide={toggleModal}
      >
        <Modal.Header closeButton>
          <p className='fw-medium m-0'>{title}</p>
        </Modal.Header>
        <Modal.Body>
          {instructions}
          <button className='mt-2 n-btn btn-forest-green' onClick={toggleModal}>
            Stäng
          </button>
        </Modal.Body>
      </Modal>
      <GlobalModalStyle/>
    </div>
  );
};

export default InfoIcon;